/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseOrderResource
 */
export interface PurchaseOrderResource {
    /**
     * The internal purchaseOrder registration id if exists
     * @type {string}
     * @memberof PurchaseOrderResource
     */
    id?: string;
    /**
     * The purchaseOrder number of the client
     * @type {string}
     * @memberof PurchaseOrderResource
     */
    identifier?: string;
    /**
     * The budget amount (including taxes) allowed by this purchase order
     * @type {number}
     * @memberof PurchaseOrderResource
     */
    budget?: number;
    /**
     * A simple comment to insert along with the purchase order
     * @type {string}
     * @memberof PurchaseOrderResource
     */
    comment?: string;
}

/**
 * Check if a given object implements the PurchaseOrderResource interface.
 */
export function instanceOfPurchaseOrderResource(value: object): value is PurchaseOrderResource {
    return true;
}

export function PurchaseOrderResourceFromJSON(json: any): PurchaseOrderResource {
    return PurchaseOrderResourceFromJSONTyped(json, false);
}

export function PurchaseOrderResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'budget': json['budget'] == null ? undefined : json['budget'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PurchaseOrderResourceToJSON(value?: PurchaseOrderResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'identifier': value['identifier'],
        'budget': value['budget'],
        'comment': value['comment'],
    };
}

